<template>
    <div class="Newitem">
      <!-- 弃用 -->
      <div v-if="!shownull">
        <div class="New-card flex flex-j-c-sb" v-for="(item, index) in newData" :key="index" @click="toDetail(item)">
          <div class="Newitem-msg flex flex-j-c-sb">
            <p class="msg-title ellipsis-more" style="-webkit-line-clamp: 3;">{{item.title}}</p>
            <p class="msg-time">{{item.addtime}}</p>
          </div>
          <img class="Newitem-img" v-lazy="item.cover_pic" />
        </div>
      </div>
      <DataNull v-if="shownull"/>
      <Nomore v-if="showNoMore"/>
    </div>
</template>

<script>
import {NoticeList} from '@/api';
import { MessageBox } from 'mint-ui';
import DataNull from '@/components/DataNull';
import Nomore from '@/components/Nomore';

export default {
  name: 'NewsCard',
  components: {
    DataNull,
    Nomore
  },
  data() {
    return {
      newData: [], // 新闻列表数据
      page: 1, // 页数
      loading: true,
      shownull: false,
      pagetype: 3, // 页面类型
      showNoMore: false
    }
  },
  created() {
    if (sessionStorage.getItem('_pageType') === 'article') {
      this.pagetype = 7;
    } else {
      this.pagetype = 3;
    }
    this.getList();
  },
  methods: {
    /**
     * 跳转详情
     * e  选择的文章
     */
    toDetail(e) {
      let uid = JSON.parse(localStorage.getItem('cww_data')).id;
      window.location.href = `${window.location.origin}/NoticeDetail?id=${e.id}&invitorId=${uid}`
    },
    // 加载更多
    loadMore(){
      if (this.loading) return false;
      this.loading = true
      this.page += 1;
      this.getList();
    },
    // 数据获取
    getList() {
      
      NoticeList({type: this.pagetype, page: this.page, limit: 10}).then(res => {
        this.newData = this.newData.concat(res.data.list);
        if (res.data.list.length === 0) { this.shownull = true; };
        if (res.data.list.length === 10) { this.loading = false; };
        if (res.data.list.length !== 10 && res.data.list.length !== 0) { this.showNoMore = true };
        if (res.code !== 0) { this.shownull = true; };
      })
    }
  },
};
</script>

<style scoped lang="less">
image[lazy=loading] {
  width: 100%;
  height: 100%;
  margin: auto;
}
.Newitem{
  .New-card{
    background: white;
    width: 100%;
    border-bottom: 0.5px solid #EEEEEE;
    padding: 0.16rem;
    margin-top: 0.1rem;
    .Newitem-msg{
      max-width: 70%;
      text-align: left;
      flex-direction: column;
      font-size: 0.15rem;
      color: #000000;
      .msg-time{
        color: #666666;
        font-size: 0.12rem;
      }
    }
    .Newitem-img{
      width: 0.8rem;
      height: 0.8rem;
    }
  }
}
</style>
